import './App.css';

import { JourneyWrapper } from './pages/wrappers/JourneyWrapper';
import { BrowserRouter as Router } from 'react-router-dom';
import HtmlAttributesUpdater from "./utils/HtmlAttributesUpdater";
import { useDispatch } from 'react-redux';

import { createBrowserHistory } from 'history';

const history = createBrowserHistory();

function App() {
    const path = (/#!(\/.*)$/.exec(window.location.hash) || [])[1];
    if (path) {
        history.replace(path);
    }

    // const dispatch = useDispatch();
    return (
        <Router>
            <div className="App">
                <HtmlAttributesUpdater />
                <JourneyWrapper />
            </div>
        </Router>
    );
}

export default App;